import { Body, Controller, Get, Param, Post, Query, UploadedFile, UseInterceptors } from '@nestjs/common';
import { BloodDonationCertificateResponse, BroadcastSummaryResponse, CommonResponse, GlobalResponseObject } from '@schemax-whatsapp/shared-models';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { MessageRequest } from './dto/message.request';
import { MessageBroadcastService } from './message-broadcast.service';
import { BroadcastMessageRequest } from './dto/broadcast-message.request';
import { BMIdRequest } from './dto/bm-id.request';
import { CompanyIdRequest } from '../company/models/company-id.request';
import { BroadcastInfoService } from './broadcast-info.service';
import { CompanyIdDateRangeRequest } from './dto/company-id-date-range.request';
import { BloodDonationUserRequest } from './dto/blood-donation-user.request';
import { ApiTags,ApiConsumes } from '@nestjs/swagger';
import { FileInterceptor } from '@nestjs/platform-express'
import { diskStorage } from 'multer';
import { extname } from 'path';
import { UploadDto } from '../bi-message/models/upload.request';

@Controller('message-broadcast')
export class MessageBroadcastController {

    constructor(
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
        private msgBroadCastService: MessageBroadcastService,
        private broadcastInfoService: BroadcastInfoService,
    ) {

    }
    
    /**
     * 
     * @param body 
     * @returns 
     */
    @Post('/sendMessage')
    async sendMessage(@Body() msgReq: MessageRequest): Promise<GlobalResponseObject> {
        try {
            return await this.msgBroadCastService.sendMessage(msgReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    /**
     * Broadcasts the given message to users
     * @param msgReq 
     * @returns 
     */
    @Post('/saveBroadCastedMessageToMultipleCustomers')
    async saveBroadCastedMessageToMultipleCustomers(@Body() msgReq: BroadcastMessageRequest): Promise<CommonResponse> {
        try {
            return await this.msgBroadCastService.saveBroadCastedMessageToMultipleCustomers(msgReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    /**
     * 
     * @param bmIdReq 
     */
    @Post('/triggerMessageBroadCasting')
    async triggerMessageBroadCasting(@Body() bmIdReq: BMIdRequest): Promise<GlobalResponseObject> {
        try {
            return await this.msgBroadCastService.triggerMessageBroadCasting(bmIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    /**
     * 
     * @param companyIdReq 
     * @returns 
     */
    @Post('/getBroadCastSummaryStatusForCompany')
    async getBroadCastSummaryStatusForCompany(@Body() companyIdReq: CompanyIdDateRangeRequest): Promise<BroadcastSummaryResponse> {
        try {
            return await this.broadcastInfoService.getBroadCastSummaryStatusForCompany(companyIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }


    @Post('/sendBloodDonationMessage')
    async sendBloodDonationMessage(@Body() req: BloodDonationUserRequest): Promise<BloodDonationCertificateResponse> {
        try {
            return await this.msgBroadCastService.sendBloodDonationMessage(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BloodDonationCertificateResponse, error);
        }
    }

    @Get('/renderBloodDonationCertificate/:username/:contact/:date')
    async renderBloodDonationCertificate(@Param() params:  { username: string, contact: string, date: string }): Promise<any> {
        try {
            return await this.msgBroadCastService.renderBloodDonationCertificate(params.username, params.contact, params.date);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    @Post('/broadcastMessageUsingFbTesting')
    async broadcastMessageUsingFbTesting(): Promise<string> {
        try {
            return await this.msgBroadCastService.broadcastMessageUsingFb([], '', '', 'en');
        } catch (error) {
            return error;
        }
    }

    @Post('/messagePhotoUpload')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
      limits: { files: 1 },
      storage: diskStorage({
        destination: './message-uploads/bi-photos',
        filename: (req, file, callback) => {
          const name = file.originalname.split('.')[0];
          const fileExtName = extname(file.originalname);
          const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
          callback(null, `${name}-${randomName}${fileExtName}`);
        },
      }),
      fileFilter: (req, file, callback) => {
        if (!file.originalname.match(/\.(png|jpeg|PNG|jpg|JPG)$/)) {
          return callback(new Error('Only png,jpeg,PNG,jpg,JPG files are allowed!'), false);
        }
        callback(null, true);
      },
    }))
  
    async messagePhotoUpload(@UploadedFile() file, @Body() uploadData: UploadDto): Promise<CommonResponse> {
      try {
        console.log('--------file------',file)
        return await this.msgBroadCastService.updatePath(file.path,file.filename, uploadData.id)
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/createTemplate')
    async createTemplate(@Body() msgReq: BroadcastMessageRequest): Promise<CommonResponse> {
        try {
          console.log('--------file------')
          return await this.msgBroadCastService.createTemplate(msgReq)
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
      }
    
}
